<script setup lang="ts">

</script>

<template>
  <VApp>
    <VMain>
      <router-view />
    </VMain>
    <SlideOutPanel />
  </VApp>
</template>
